/**
 * Created by andreyna on 6/21/2017.
 */
import BaseComponent from '../../base/base_component';
import GameItemComponentModel, { IButtonInfo } from './game_item_component_model';
import { GAME_ITEM_CLASSES } from './game_item_component_consts';
import { FP_VOUCHER_ICONS_CLASSES } from '../free_play/voucher/free_play_voucher_consts';
import _ from '../../utils/underscore';
import DOM from '../../utils/dom';
import Directive from '../../core/directive';
import { USER_EVENTS } from '../../events/events';
import { ILocalizedGameInfo } from '../../services/games_information/games_information_service_interface';

const GAME_ITEM_VIEW = require('./view/game_item.html');

/**
 * THIS COMPONENT WAS MIGRATED TO ORBIT, game-iem.component.tsx. But this is also used in fp_games_component_controller.ts
 * When free play will be migrated to orbit, don't bother to migrate this component again, just use the one in orbit.
 * And delete this one along with it's model, view and css
 */
export default class GameItemComponentController extends BaseComponent {

    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameItemComponentController';

    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-game-item-component';

    _model: GameItemComponentModel;

    init(params) {
        super.init(params);
        this._model = GameItemComponentModel.create(params);
    }


    /**
     * Start bake the component
     */
    start() {
        const gameData = this._model.getGame();
        this._bakeGameItem(gameData)
            ._injectButtons()
            ._setGameThumbnail(gameData)
            ._injectJackpot(gameData);

        this.updateDisplayState(this._model.getShow());
        return this;
    }

    updateDisplayState(display: boolean) {
        this._model.setShow(display);

        if (!display) {
            DOM.addClass(this.getEl(), 'cgp-hide');
        } else {
            DOM.removeClass(this.getEl(), 'cgp-hide');
        }
    }


    /**
     * Bake voucher game HTML
     * @private
     */
    private _bakeGameItem(gameData) {
        let cssClasses = this._model.getItemClass();
        if (this._model.getShow()) {
            cssClasses += " cgp-hide";
        }

        const gameItemHTML = this.bake(GAME_ITEM_VIEW,
            Object.assign({}, {
                gameId: gameData.gameTypeID,
                gameTitle: gameData.title,
                itemClass: cssClasses,
            },
                this._getFreePlayBindingProps())
        );
        this.setHTML(gameItemHTML);
        return this;
    }


    private _injectButtons() {
        const buttons = this._model.getButtons();
        if (!buttons || !_.isArray(buttons) || buttons.length === 0) {
            // inject default button
            this._injectButton({
                textKey: this._model.getPlayBtnText(),
                classList: [GAME_ITEM_CLASSES.GAME_ITEM_DEFAULT_BTN_CLASS],
                onClick: () => {
                    this._model.getOnClickHandler().call(this);
                }
            });
        } else {
            buttons.forEach((btnOptions) => {
                this._injectButton(btnOptions);
            });
        }

        return this;
    }


    private _injectButton(btnOptions: IButtonInfo) {
        const btnAreaEl = this.getDOMElementByClassName(GAME_ITEM_CLASSES.GAME_ITEM_BTN_AREA);
        const btnEl = DOM.createElement('button', this.serviceFactory.languageService().translation(btnOptions.textKey));
        let classes = [GAME_ITEM_CLASSES.GAME_ITEM_PLAY_BTN, GAME_ITEM_CLASSES.GAME_ITEM_BTN_FONT];
        if (btnOptions.classList) {
            classes = classes.concat(btnOptions.classList);
        }

        DOM.addClass(btnEl, classes);
        DOM.append(btnAreaEl, btnEl);
        if (_.isFunction(btnOptions.onClick)) {
            this.onDOMEvent(btnEl, USER_EVENTS.ON_CLICK, () => {
                btnOptions.onClick.call(this);
            });
        }
    }


    /**
     * Get Binding properties for Free Play game
     * @returns {{}}
     * @private
     */
    private _getFreePlayBindingProps() {
        let props = {};
        const fpType = this._model.getFPType();
        if (fpType) {
            props = {
                fpThumbClass: FP_VOUCHER_ICONS_CLASSES[fpType]
            };
        }
        return props;
    }


    /**
     * Append game jackpot component to the game item
     * @private
     */
    private _injectJackpot(gameData: ILocalizedGameInfo) {
        const jackpotComponent = Directive.generate({
            directiveName: 'game_jackpot',
            start: false,
            props: {
                gametypeid: gameData.gameType
            }
        });
        this._model.setJackpotRef(jackpotComponent);
        jackpotComponent.start();
        DOM.append(this.getDOMElementByClassName(GAME_ITEM_CLASSES.GAME_JACKPOT_CONTAINER_CLASS), jackpotComponent.getEl());
        return this;
    }


    /**
     * Load game thumbnail
     * @param gameData
     * @returns {Promise<U>|*|Promise.<TResult>}
     * @private
     */
    private _setGameThumbnail(gameData) {
        const img = DOM.createElement('div');
        DOM.addClass(img, 'cgp-game-item-thumbnail');
        DOM.addAttribute(img, 'style',
          'background-image:url(' + this._getResolvedGameImagePath(gameData) + ')');
        DOM.append(this.getDOMElementByClassName('cgp-game-item-img-wrapper'), img);
        return this;
    }

    private _getResolvedGameImagePath(gameData) {
        return this.serviceFactory.gameService().resolveGameImagePath(gameData.images && gameData.images.icon);
    }


    shutDown() {
        super.shutDown();
        this.logger.debug('Game item component shut down');
    }
}
